import React, { useContext, useEffect } from "react";
import { Button, Grid, Stack } from "@mui/material";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { FormattedMessage, useIntl } from "react-intl";
import { theme } from "../../styles/themeProvider";
import { findComponentStep } from "../../utils/filter";
import { Service } from "../../types/entities";

//The home component has the buttons so the user can choose the flow they want.
export const Home = () => {
	const { formatMessage } = useIntl();
	const { flows, setSelectedFlow, services } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;
	const { onNext, onReset, reservation, onChangeStep, onChangeService } =
		useContext(MultistepContext) as MultistepContextValues;

	// If we are in the home step, we clean the reservation.
	// Once the token is fetched, call the hooks
	// eslint-disable-next-line
	useEffect(() => {
		// If the reservation is already created, we redirect to the details step
		const redirectStep = async () => {
			let detailStep;
			if (reservation.service?.category!.name === "Restaurant") {
				detailStep = findComponentStep(flows[0], "Details");
				setSelectedFlow(flows[0]);
			} else {
				detailStep = findComponentStep(flows[1], "Details");
				setSelectedFlow(flows[1]);
			}
			onChangeStep(detailStep);
		};

		if (reservation.id) {
			redirectStep();
		} else {
			//If we are in the home step, we clean the reservation.
			// eslint-disable-next-line
			onReset();
		}
	}, [reservation.id]);

	let isRestaurantAvailable = false;
	let isExperiencesAvailable = false;
	const events: Service[] = [];

	services.forEach((service) => {
		const categoryName = service.category.name;
		if (categoryName === "Restaurant") {
			isRestaurantAvailable = true;
		} else if (categoryName === "Event") {
			events.push(service);
		} else {
			isExperiencesAvailable = true;
		}
	});

	const handleNext = (flowNumber: number, service?: Service) => {
		setSelectedFlow(flows[flowNumber]);
		if (service) onChangeService(service);
		onNext();
	};

	return (
		<Stack sx={styles.buttonGroupContainer} spacing={2.5}>
			{isRestaurantAvailable && (
				<Button
					variant="outlined"
					fullWidth
					onClick={() => {
						handleNext(
							0,
							services.find((s) => s.category.name === "Restaurant")!
						);
					}}
					sx={{ height: "50px", borderColor: theme.palette.primary.main }}
				>
					{formatMessage({
						id: flows[0].name,
						defaultMessage: "Reservar en el restaurante",
					})}
				</Button>
			)}
			<Grid
				container
				spacing={2}
				sx={{
					width: "calc(100% + 16px)",
					marginLeft: "-16px !important",
					marginTop: "0px !important",
				}}
			>
				{isExperiencesAvailable && (
					<Grid
						item
						mobile={12}
						sm={events.length > 1 || events.length === 0 ? 12 : 6}
						padding={0}
					>
						<Button
							variant="contained"
							fullWidth
							onClick={() => handleNext(1)}
							sx={{ height: "50px" }}
						>
							{formatMessage({
								id: flows[1].name,
								defaultMessage: "Ver nuestras experiencias",
							})}
						</Button>
					</Grid>
				)}
				{events.map((event, index) => (
					<Grid
						item
						mobile={12}
						sm={
							/* If the events number is odd and the experience is not available,
							or if it is available but the number of events is more than one, then the  
							button will use 12 spaces if it is the last one, if not, it will use 6*/
							((isExperiencesAvailable && events.length > 1) ||
								!isExperiencesAvailable) &&
							events.length % 2 !== 0 &&
							index === events.length - 1
								? 12
								: 6
						}
						key={index}
					>
						<Button
							variant="contained"
							fullWidth
							onClick={() => {
								handleNext(1, event);
							}}
							sx={{
								height: "50px",
								backgroundColor: theme.palette.primary.light,
								"&:hover": { backgroundColor: theme.palette.primary.light },
							}}
						>
							<FormattedMessage
								defaultMessage="Reservar para"
								id="home.bookEventTitle"
							/>
							{" " + event.name}
						</Button>
					</Grid>
				))}
			</Grid>
		</Stack>
	);
};

const styles = {
	buttonGroupContainer: {
		width: "100%",
		pb: 3.5,
		justifyItems: "center",
	},
};
